<div id="managePopUp">
  <div class="modal-header">
    <span class='modal-title'>{{authoringContentData?.cancelService?.errorTitle}}</span>
    <button type="button" class="close" aria-label="Close" (click)="exit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
        <div>
            <p class="headerPart">
              {{authoringContentData?.cancelService?.errorBody}}
            </p>
        </div>
    </div>
    <div class="modal-footer pull-right popup_btnbox bottom_aligner">
        <div class='btnFullWidth'>
            <button type='button' class='primary_btn' (click)="exit()">{{authoringContentData?.cancelService?.doneCTA}}</button>
        </div>
  </div>

</div>
